import { DocumentNames } from '@commenda/utils/enums';

import { SWRFetcher } from '@commenda/utils/logical-backend-fetcher';
import useSWR, { KeyedMutator } from 'swr';

export function useGetFiles({
  corporationId,
  serviceRequestId,
  excludeDocumentNames,
  enabled = true,
}: {
  corporationId: number;
  serviceRequestId: string;
  excludeDocumentNames?: string[];
  enabled?: boolean;
}) {
  let url = 'file';

  const queryParams = new URLSearchParams();

  queryParams.append('corporationId', corporationId.toString());
  queryParams.append('serviceRequestId', serviceRequestId);

  if (queryParams.toString() !== '') {
    url += `?${queryParams.toString()}`;
  }

  const {
    data,
    error,
    mutate,
  }: {
    data?: {
      fileUrl: string;
      id: number;
      key: string;
      documentName: DocumentNames;
      explicitDocumentType: string;
      samplePdfUrl: string | null;
      metadata: {
        type: string;
        serviceRequestId: string;
        documentName: string;
        isSigned?: boolean;
        isPdfDownloadable?: boolean;
      };
    }[];
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    enabled ? url : null,
    SWRFetcher(
      {
        method: 'GET',
      },
      undefined
    )
  );

  const filteredData = data?.filter((f) => {
    if (excludeDocumentNames) {
      return !excludeDocumentNames.includes(f.documentName);
    }
    return true;
  });

  return {
    data: filteredData,
    error,
    mutate,
  };
}
